import type { ChatMessage } from '../types/chat';

/**
 * CORE-1253 / CORE-1820 — история чата эфира с начала, по страницам.
 *
 * REST `GET /api/lives/{id}/chat` отдаёт не больше 200 последних сообщений за
 * раз, а `?beforeId=` — сообщения старше указанного, по возрастанию, не больше
 * `limit`. Страница короче `limit` значит, что дошли до начала. Листаем назад,
 * пока не дошли или пока не набрали `max` — больше веб на экране не держит.
 *
 * Сервер без курсора (стенд до CORE-1820) молча отдаёт ту же последнюю
 * страницу: её самое старое сообщение не старше прежнего курсора, и на этом
 * останавливаемся, а не крутим одну и ту же страницу.
 */
export async function loadLiveChatHistoryPages(
  fetchPage: (beforeId: number | null) => Promise<ChatMessage[]>,
  onPage: (page: ChatMessage[]) => void,
  { pageSize, max, isCancelled }: { pageSize: number; max: number; isCancelled: () => boolean },
): Promise<void> {
  let beforeId: number | null = null;
  let loaded = 0;
  while (loaded < max) {
    const page = await fetchPage(beforeId);
    if (isCancelled() || !page?.length) return;
    onPage(page);
    loaded += page.length;
    if (page.length < pageSize) return;
    const oldest = Math.min(...page.map(m => m.id));
    if (beforeId !== null && oldest >= beforeId) return;
    beforeId = oldest;
  }
}
